import { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SocialMediaLinksProps {
	socialMediaLinks: {
		url: string;
		icon: IconDefinition;
	}[];
	className?: string;
	linkClassName?: string;
	iconClassName?: string;
}

export const SocialMediaLinks = ({ socialMediaLinks, className, linkClassName, iconClassName }: SocialMediaLinksProps) => {
	return (
		<div className={className}>
			{socialMediaLinks
				.filter((link) => link.url)
				.map(({ url, icon }) => (
					<a key={url} href={url} className={linkClassName} rel="noopener noreferrer" target="_blank">
						<FontAwesomeIcon icon={icon} className={`size-5 ${iconClassName}`} />
					</a>
				))}
		</div>
	);
};
